import React, { useState, useEffect } from "react";
import styles from './.FilterBoxComponents.module.css';
import headcountStyles from './CompanyHeadcountFilter.module.css';
import { formatWithCommas } from "functions/fields";

const HeadcountFilter = ({ employees, setEmployees }) => {
    const [localEmployees, setLocalEmployees] = useState(["", ""]);

    useEffect(() => {
        // Sync local state when employees prop changes
        const synced = [
            employees?.[0] !== null && !isNaN(employees?.[0]) ? String(employees[0]) : "",
            employees?.[1] !== null && !isNaN(employees?.[1]) ? String(employees[1]) : ""
        ];
        setLocalEmployees(synced);
    }, [employees]);

    const handleChange = (e, index) => {
        const raw = e.target.value.replace(/,/g, "");
        const cleaned = raw.replace(/[^\d]/g, ""); // Only digits
        const updated = [...localEmployees];
        updated[index] = cleaned;
        setLocalEmployees(updated);
    };

    const handleBlur = () => {
        let [minStr, maxStr] = localEmployees;

        const min = /^\d+$/.test(minStr) ? Number(minStr) : null;
        const max = /^\d+$/.test(maxStr) ? Number(maxStr) : null;

        let updatedMin = min;
        let updatedMax = max;

        if (min !== null && max !== null && max < min) {
            updatedMax = min;
        }

        if (updatedMin === null && updatedMax === null) {
          setEmployees([]);  // So it's entirely omitted or serialized as null
        } else {
          setEmployees([updatedMin, updatedMax]);
        }

        setLocalEmployees([
            updatedMin === null ? "" : String(updatedMin),
            updatedMax === null ? "" : String(updatedMax)
        ]);
    };

    return (
        <div className={styles.accordionContent}>
            <label>Company headcount is between:</label>
            <div className={headcountStyles.employeeHeadcountRange}>
                <div className={headcountStyles.headcountInputContainer}>
                    <input
                        type="text"
                        value={localEmployees[0] === "" ? "" : formatWithCommas(localEmployees[0])}
                        onChange={(e) => handleChange(e, 0)}
                        onBlur={handleBlur}
                        placeholder="No min"
                    />
                    <label>Min</label>
                </div>
                <div className={headcountStyles.headcountInputContainer}>
                    <input
                        type="text"
                        value={localEmployees[1] === "" ? "" : formatWithCommas(localEmployees[1])}
                        onChange={(e) => handleChange(e, 1)}
                        onBlur={handleBlur}
                        placeholder="No max"
                    />
                    <label>Max</label>
                </div>
            </div>
        </div>
    );
};

export default HeadcountFilter;
